import { render } from "./MultiselectSearch.vue?vue&type=template&id=44fe1c2c"
import script from "./MultiselectSearch.vue?vue&type=script&lang=js"
export * from "./MultiselectSearch.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./MultiselectSearch.vue?vue&type=style&index=0&id=44fe1c2c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script